export default "__VITE_ASSET__Bd7qfCXz__"